import React from "react";
import { Slide } from "react-slideshow-image";
import ResponsiveImage from "../ImageLoader/ResponsiveImage";

const properties = {
  duration: 5000,
  transitionDuration: 500,
  infinite: true,
  indicators: true,
  arrows: false,
  pauseOnHover: false,
};

const Slideshow = ({ images }) => {
  if (!images || images.length === 0) {
    return <></>;
  }

  return (
    <div className="slide-container">
      <Slide {...properties} autoplay={images.length > 1}>
        {images.map((slide, index) => (
          <div className="each-slide" key={index}>
            <ResponsiveImage image={`${slide}?q=90`} loaded={true} />
          </div>
        ))}
      </Slide>
    </div>
  );
};

export default Slideshow;
